import { render, staticRenderFns } from "./overview.vue?vue&type=template&id=a87208f6&scoped=true"
import script from "./overview.vue?vue&type=script&lang=js"
export * from "./overview.vue?vue&type=script&lang=js"
import style0 from "./overview.vue?vue&type=style&index=0&id=a87208f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87208f6",
  null
  
)

export default component.exports